export default "__VITE_ASSET__CSmLyRrY__"